export default "__VITE_ASSET__DAHqtQ$z__"